// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"styles_menuWrapper__3ogGk","navigationsWrapper":"styles_navigationsWrapper__2HOfW","divider":"styles_divider__rIUSR"};